<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn_160" v-if="onlineLearn == 1">
      <el-select
        class="select_btn_style"
        v-model="filters.onlineLearnStatus"
        placeholder="在线课件学习情况"
      >
        <el-option
          v-for="(item, i) in learnData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn m-l-14">
      <el-select
        class="select_btn_style"
        v-model="filters.graduationStatus"
        placeholder="结业状态"
      >
        <el-option
          v-for="(item, i) in graduationStatusData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn m-l-14">
      <el-select
        class="select_btn_style"
        v-model="filters.enrollStatus"
        placeholder="报名状态"
      >
        <el-option
          v-for="(item, i) in enrollStatusData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        size="small"
        v-model.trim="filters.name"
        placeholder="姓名"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="initData"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import { getEnums } from "@/utils/common.js";
export default {
  components: { butn },
  props: {
    onlineLearn: {
      default: 0,
    }
  },
  data() {
    return {
      filters: {},
      enrollStatusData: [],
      learnData: [],
      graduationStatusData: []
    };
  },
  created() {
   
    getEnums(
      ["FINISH_STATUS", "CLASS_ENROLL_STATUS", 'CLASS_FINISH_STATUS'],
      this,
      ["learnData", "enrollStatusData", 'graduationStatusData'],
      [true, true, true]
    );
  },
  methods: {
    initData() {
      this.$emit("search", this.filters);
    },
    resetData() {
      this.filters = {};
      this.initData();
    }
  }
};
</script>

<style lang="scss" scoped>
.serach-form {
  text-align: right;
}
</style>
